import React from 'react';
import { MessageNewSystemStyle } from './style';

export default function MessageNewSystem() {
  return (
    <MessageNewSystemStyle>
      <div>
        <div>
          <img src="/images/icons/iconAlert.svg" alt="Ícone de Alerta" />
        </div>
        <h3>Atenção</h3>
      </div>
      <p>
        Em breve esse link de acesso ao sistema será descontinuado. Para acessar a nova plataforma clique no botão
        abaixo.
      </p>
      <a href="https://portal-spa-digital.vercel.app">Clique aqui</a>
    </MessageNewSystemStyle>
  );
}
